import { PageToolbar } from '@app/components/page-toolbar/PageToolbar';
import { LinkItem, NavLinksMUI } from '@mi-front/ui';
import { Box } from '@mui/material';
import { PageActions } from './PageActions';
import { PageTitle } from './PageTitle';

interface Props {
  icon?: React.ReactNode;
  title?: React.ReactNode | React.ReactNode[];
  actions?: React.ReactNode;
  breadcrumbs?: React.ReactNode;
  backBtn?: boolean | string;
  tabs?: readonly LinkItem[];
}

export function PageHeader({ icon, title, actions, breadcrumbs, backBtn, tabs }: Props) {
  return (
    <PageToolbar
      sx={{
        pb: tabs ? 0 : 1.25,
      }}
    >
      {breadcrumbs}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mt={breadcrumbs ? 1 : 0}
        height="40px"
      >
        <PageTitle icon={icon} title={title} backBtn={backBtn} />
        <PageActions actions={actions} />
      </Box>

      {!!tabs && (
        <Box mt={1}>
          <NavLinksMUI links={tabs} />
        </Box>
      )}
    </PageToolbar>
  );
}
